import { useMemo } from 'react';
import { useI18n } from '@/hooks/useI18n';
import {
  formatoFecha,
  formatoFechaDeCalendario,
  formatoFechaHora,
  formatoFechaHoraFija,
  formatoNumero,
} from '@/i18n/formato';

/**
 * Números y fechas en la configuración regional del idioma activo.
 *
 * Sustituye a los `toLocaleString('es-MX')` que había repartidos por las
 * pantallas; `formato.test.ts` falla si vuelve a aparecer uno.
 */
export function useFormato() {
  const { locale } = useI18n();

  return useMemo(
    () => ({
      numero: (valor: number, opciones?: Intl.NumberFormatOptions) =>
        formatoNumero(locale, valor, opciones),
      fecha: (iso?: string | null) => formatoFecha(locale, iso),
      /** Un día, no un instante: anclado a UTC. Ver `formatoFechaDeCalendario`. */
      fechaDeCalendario: (iso?: string | null) => formatoFechaDeCalendario(locale, iso),
      fechaHora: (iso?: string | null) => formatoFechaHora(locale, iso),
      /** Solo para fechas de demostración. Ver `formatoFechaHoraFija`. */
      fechaHoraFija: (iso?: string | null) => formatoFechaHoraFija(locale, iso),
    }),
    [locale],
  );
}
